@if (currentConfig.form!=undefined && (data?.objectId != undefined?currentConfig.formVal!=undefined:true)) {
  <dhs-form
    [formtype]="''" [config]="currentConfig.config" [fieldGroup]="currentConfig.form" [decorator]="self"
    [data]="currentConfig.formVal!=undefined?currentConfig.formVal:''" [action]="'ADD'" (saveFinished)='saveFinished($event)'>
  </dhs-form>
}